import * as React from 'react'
import { PaymentLink } from './payment-link-ui'
import './styles.scss'

export const PaymentInstruction = () => (
  <>
    Click <PaymentLink /> and follow instructions to pay electronically.
  </>
)
